/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { followedUserProfileSchema } from "./followedUserProfileSchema.ts"
import { z } from "zod/v4"

export const getUserProfilePathParamsSchema = z.object({
  id: z.string(),
})

/**
 * @description Successfully fetched the profile of a user you follow
 */
export const getUserProfile200Schema = followedUserProfileSchema

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const getUserProfile401Schema = APIErrorSchema

/**
 * @description You don\'t follow this user
 */
export const getUserProfile403Schema = APIErrorSchema

/**
 * @description User not found
 */
export const getUserProfile404Schema = APIErrorSchema

export const getUserProfileQueryResponseSchema = getUserProfile200Schema
